var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 64,
    cy: 64,
    r: 56
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.1%",
    y: "-5.4%",
    width: "114.3%",
    height: "114.3%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.240942029 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "d",
    cx: 64,
    cy: 63,
    r: 52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#492779",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#892793",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 64.034c0 23.025 14.885 42.472 35.555 49.367 2.6.456 3.575-1.105 3.575-2.47 0-1.237-.065-5.334-.065-9.692C38 103.644 34.62 98.05 33.58 95.124c-.585-1.496-3.12-6.114-5.33-7.35-1.82-.976-4.42-3.382-.065-3.447 4.095-.065 7.02 3.772 7.995 5.333 4.68 7.87 12.155 5.66 15.145 4.293.455-3.382 1.82-5.66 3.315-6.96-11.57-1.3-23.66-5.788-23.66-25.69 0-5.66 2.015-10.343 5.33-13.985-.52-1.3-2.34-6.634.52-13.79 0 0 4.355-1.365 14.3 5.334 4.16-1.17 8.58-1.756 13-1.756s8.84.586 13 1.756c9.945-6.764 14.3-5.333 14.3-5.333 2.86 7.154 1.04 12.487.52 13.788 3.315 3.642 5.33 8.26 5.33 13.984 0 19.968-12.155 24.39-23.725 25.692 1.885 1.626 3.51 4.748 3.51 9.626 0 6.96-.065 12.553-.065 14.31 0 1.365.975 2.99 3.575 2.47C101.115 106.507 116 86.995 116 64.035 116 35.284 92.73 12 64 12S12 35.285 12 64.034z",
    id: "e"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-.5%",
    y: "-.5%",
    width: "101%",
    height: "102%",
    filterUnits: "objectBoundingBox",
    id: "f"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.529296875 0",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-1%",
    y: "-1%",
    width: "101.9%",
    height: "103%",
    filterUnits: "objectBoundingBox",
    id: "h"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.258823529 0 0 0 0 0.137254902 0 0 0 0 0.431372549 0 0 0 0.703549592 0",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h128v128H0z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    strokeOpacity: 0.5,
    stroke: "#BABABA",
    strokeWidth: 2,
    fillOpacity: 0,
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#c)",
    cx: 64,
    cy: 64,
    r: 56
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#f)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#g)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#h)",
    xlinkHref: "#e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/github-logo.3657a04f358cf4893c41a51d1ed3bccd.svg";
export { ForwardRef as ReactComponent };